module.exports = __webpack_public_path__ + "resources/icon-check-50.77e157af7015a2fb.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-gift/img/icon-check-50.png
// module id = 777
// module chunks = 0 1